import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox, DialogContentText } from '@mui/material';
import Button from 'react-bootstrap/Button';
import { useRemoveTripFromOrderMutation } from '../../../features/Dispatch/TripDispatchSlice';
import { toast } from 'react-toastify';

const RemoveTrip = (props) => {
    const [removeTrip] = useRemoveTripFromOrderMutation();
    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    const handleConfirm = async () => {
        const body = {
            orderId: props.orderID,
            divisionId: props.divisionId,
            orderNumber: props.orderNumber,
        };
        const result = await removeTrip(body);
        if (result.data?.statusCode === 200) {
            toast.success(result.data.message, { position: 'top-center' });
            props.getAllOpenTripOrders(props.divisionId);
            props.getTripOrdersClassification({ tripStatus: statusMap[props?.selectedTrip.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionId })
            props.setShowRemoveTrip(false);
        } else {
            toast.error(result.error?.data.message, { position: 'top-center' });
        }
    };

    return (
        <Dialog open={props.showRemoveTrip} onClose={() => props.setShowRemoveTrip(false)}>
            <DialogTitle  style={{backgroundColor: '#bf2527', color: 'white'}}>Remove Order From Trip</DialogTitle>
            <DialogContentText style={{ padding: '20px', fontSize: '16px' }}>
                Are you sure you want to remove order {props.orderNumber} from trip ({props.selectedTrip?.tripNo})?
            </DialogContentText>
            <DialogActions>
                <div className='d-flex gap-3 p-3 justify-content-end'>
                    <Button style={{ width: "120px" }} className='btn-secondary' onClick={() => props.setShowRemoveTrip(false)}>Cancel</Button>
                    <Button style={{ width: "120px" }} className="btn-primary" onClick={handleConfirm}>
                        Confirm
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default RemoveTrip;